export const routes = {
  createDedicatedOffer : "approvals/dedicated",
  createSingleOffer    : "approvals/single",
  updateOfferQueue     : (approvalId: number) => `approvals/queue/${approvalId}`,
  getApprovalsQueue    : "approvals/queue",
  getUsers             : "users",
  getOrders            : "orders",
  getLocations         : "locations",
  getEquipmentTypes    : "equipment-types",
  getCarriers          : "carriers",
  deleteApprovalQueue  : (approval_id: number) => `approvals/queue/${approval_id}`,
  updateStatusQueue    : (approval_id: number) => `approvals/queue/${approval_id}/status`,
  getApprovalsHistory  : "approvals/history",
};
